import classNames from 'classnames';
import * as React from 'react';
import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    button: {
        color: 'white',
        minWidth: 60,
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        alignSelf: 'stretch',
        justifyContent: 'center',
        padding: 10,
        cursor: 'pointer',
        boxSizing: 'border-box',
        height: theme.layout.header.topBar,
        '&:hover, &:focus': {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
        '&:active, &.active': {
            backgroundColor: 'rgba(0, 0, 0, 0.2)',
        },
    },
    disabled: {
        pointerEvents: 'none',
        opacity: 0.5,
    },
}));
const HeaderButton = ({ disabled, onClick, children, testId = 'HeaderButton' }) => {
    const classes = useStyles();
    return (React.createElement("div", { role: "button", "data-testid": `${testId}`, onClick: onClick, className: classNames(classes.button, { [classes.disabled]: disabled }) }, children));
};
export default HeaderButton;
//# sourceMappingURL=HeaderButton.js.map